import { atom } from "recoil";

export const logoutState = atom({
  key: "logoutStateKey",
  default: {
    isOpen: false,
  },
});
